import { render } from "./ListIjinApproveView.vue?vue&type=template&id=42b13966"
import script from "./ListIjinApproveView.vue?vue&type=script&lang=js"
export * from "./ListIjinApproveView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__